import { DownloadSingleReportConfig, ReportFilter } from "../../types/types";
import { GenericModal } from "./common/types";

export const loadOutColumnsMetaData = {
  columns: [
    {
      headerName: "Loadout No.",
      headerParts: { top: "Loadout ", bottom: "No." },
      mappedValue: "loadNumber",
      width: 80,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Mode of Delivery",
      headerParts: { top: "Mode of ", bottom: "Delivery" },

      mappedValue: "type",
      width: 85,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Vehicle No.",
      mappedValue: "vehicleId",
      width: 90,
      headerAlign: "left",
      align: "left",
      type: "order",
      truncateText: true,
    },
    {
      headerName: "Create Date & Time",
      headerParts: { top: "Create Date ", bottom: "& Time" },
      mappedValue: "creationDate, creationTimeFormatted",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Salesman Name & ID",
      headerParts: { top: "Salesman", bottom: "Name & ID" },
      mappedValue: "salesRepName, salesmanId",
      width: 100,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Loadout Qty",
      headerParts: { top: "Loadout ", bottom: "Qty" },
      mappedValue: "totalCaseQty, totalPieceQty, totalOtherQty",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Sold Qty",
      headerParts: { top: "Sold ", bottom: "Qty" },
      mappedValue:
        "totalSoldCaseQuantity, totalSoldPieceQuantity, totalSoldOtherQuantity",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Load in Qty",
      headerParts: { top: "Load in ", bottom: "Qty" },
      mappedValue: "totalCaseLeftQty, totalPieceLeftQty, totalOtherLeftQty",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Status",
      mappedValue: "status",
      width: 100,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: [],
};

export const getStockCountColors = (inStock: boolean) => {
  if (inStock) {
    return {
      bg: "#F5FFFA",
      text: "#06A85E",
      border: "#06a85e47",
    };
  } else {
    return {
      bg: "#F4F4F4",
      text: "#7C7C7C",
      border: "#7c7c7c40",
    };
  }
};

export const initialGenericModalProps: GenericModal = {
  open: false,
  type: "positive",
  message: "",
};

export const getDownloadSingleReportConfig = (
  reportId: string,
  filters: ReportFilter[]
): DownloadSingleReportConfig => ({
  reportId,
  filters,
});

export const getGenericModalProps = (
  type: "positive" | "success" | "negative" | "error",
  message: string | any[],
  leftButtonText?: string,
  rightButtonText?: string,
  onLeftButtonClick?: () => void,
  onRightButtonClick?: () => void,
  leftButtonPadding?: string,
  confirmedOrders?: number,
  partiallyConfirmedOrders?: number,
  unavailableOrders?: number,
  width?: string
): GenericModal => {
  return {
    open: true,
    type,
    message,
    leftButtonText,
    rightButtonText,
    onLeftButtonClick,
    onRightButtonClick,
    leftButtonPadding,
    confirmedOrders,
    partiallyConfirmedOrders,
    unavailableOrders,
    width,
  };
};
